import { IPaiement } from "./Paiement.model";
import { ICommande } from "./Commande.model";

export interface IFacture {
  id?: number;
  numero?: string;
  dateFact?: any;
  commande?: ICommande;
  paiement?: IPaiement;
}

export class Facture implements IFacture {
  constructor(
    public id?: number,
    public numero?: string,
    public dateFact?: any,
    public commande?: ICommande,
    public paiement?: IPaiement
  ) {}
}
